import { RegionId } from '../region-id.enum';
import { StripeProductType } from '../stripe-product-type';
import { QCChecklistTemplateBody } from './qc-checklist-template-body.model';

/**
 * Body for POST /api/qc-checklist-templates.
 */
export interface QCChecklistTemplateCreateModel {
    readonly name: string;
    readonly isActive: boolean;
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentSubTypeOriginalId?: number | null;
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: RegionId | null;
    readonly stripeProductType?: StripeProductType | null;
    readonly body: QCChecklistTemplateBody;
}
